"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[69609],{

/***/ 70420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35851);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  border: 1px solid ',
        " !important;\n  border-color: ",
        " !important;\n  box-shadow: none !important;\n\n  :hover,\n  :focus {\n    border: 1px solid ",
        " !important;\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c892a315-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro));


/***/ }),

/***/ 84607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 *
 * @param {number} percentNum - accept value 0 until 100
 * eg:
 * import hexOpacity from "./hexOpacity";
 *
 * ...
 * ...
 *  color: ${color.primary + hexOpacity(80)}
 * ...
 *
 */ var percentToHex = function() {
    var percentNum = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return Math.round(percentNum / 100 * 255).toString(16).padStart(2, "0");
};
/* harmony default export */ __webpack_exports__["Z"] = (percentToHex);


/***/ }),

/***/ 39246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ slice; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/calendar.ts


var request = (0,requestExodus/* default */.Z)();
var CALENDAR_URL = "".concat(api/* API_EXODUS_URL */.q7, "/corpaction");
var getCalendarTodaySummary = function(symbol) {
    return request.get(CALENDAR_URL, {
        params: {
            symbol: symbol
        }
    });
};
/**
 * @summary - Get Calendar Data based on Type
 * @param {string} calendarType - type of calendar. type: economic | dividend | stocksplit
 * | reversesplit | rightissue | warrant | bonus | tenderoffer | rups | pubex | ipo
 * @return {Promise} Axios promise
 */ var getCalendarFor = function(calendarType, symbol) {
    return request.get("".concat(CALENDAR_URL, "/").concat(calendarType), {
        params: {
            symbol: symbol
        }
    });
};


;// CONCATENATED MODULE: ./src/features/calendar/slice.ts




var CONTEXT = "@feature/calendar";
var actionType = {
    GET_CALENDAR_TODAY: "".concat(CONTEXT, "/GET_CALENDAR_TODAY"),
    GET_CALENDAR_ECONOMIC: "".concat(CONTEXT, "/GET_CALENDAR_ECONOMIC"),
    GET_CALENDAR_CASH_DIVIDEND: "".concat(CONTEXT, "/GET_CALENDAR_CASH_DIVIDEND"),
    GET_CALENDAR_STOCK_DIVIDEND: "".concat(CONTEXT, "/GET_CALENDAR_STOCK_DIVIDEND"),
    GET_CALENDAR_STOCKSPLIT: "".concat(CONTEXT, "/GET_CALENDAR_STOCKSPLIT"),
    GET_CALENDAR_REVERSESPLIT: "".concat(CONTEXT, "/GET_CALENDAR_REVERSESPLIT"),
    GET_CALENDAR_RIGHTISSUE: "".concat(CONTEXT, "/GET_CALENDAR_RIGHTISSUE"),
    GET_CALENDAR_WARRANT: "".concat(CONTEXT, "/GET_CALENDAR_WARRANT"),
    GET_CALENDAR_BONUS: "".concat(CONTEXT, "/GET_CALENDAR_BONUS"),
    GET_CALENDAR_TENDER: "".concat(CONTEXT, "/GET_CALENDAR_TENDER"),
    GET_CALENDAR_RUPS: "".concat(CONTEXT, "/GET_CALENDAR_RUPS"),
    GET_CALENDAR_PUBEX: "".concat(CONTEXT, "/GET_CALENDAR_PUBEX"),
    GET_CALENDAR_IPO: "".concat(CONTEXT, "/GET_CALENDAR_IPO")
};
var initialState = {
    calendarToday: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarEconomic: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarCashDividend: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarStockDividend: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarStocksplit: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarReversesplit: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarRightIssue: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarWarrant: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarBonus: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarTender: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarRups: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarPubex: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarIpo: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    }
};
var calendarState = function(state) {
    return state.calendar;
};
var selectors = (0,es/* createSelector */.P1)(calendarState, function(calendar) {
    return {
        calendarToday: calendar.calendarToday,
        calendarEconomic: calendar.calendarEconomic,
        calendarCashDividend: calendar.calendarCashDividend,
        calendarStockDividend: calendar.calendarStockDividend,
        calendarStocksplit: calendar.calendarStocksplit,
        calendarReversesplit: calendar.calendarReversesplit,
        calendarRightIssue: calendar.calendarRightIssue,
        calendarWarrant: calendar.calendarWarrant,
        calendarBonus: calendar.calendarBonus,
        calendarTender: calendar.calendarTender,
        calendarRups: calendar.calendarRups,
        calendarPubex: calendar.calendarPubex,
        calendarIpo: calendar.calendarIpo
    };
});
/**
 * Get Calendar Data based on Type
 * @summary - available calendar type: economic | dividened | stocksplit
 * | reversesplit | reversesplit | rightissue | warrant | bonus | tenderoffer | rups | pubex | ipo
 * @param {string} calendarTypes - type of calendar
 */ var effects = {
    getCalendarToday: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_TODAY, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarTodaySummary();
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get today calendar is failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarEconomic: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_ECONOMIC, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("economic");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for economic failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarCashDividend: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_CASH_DIVIDEND, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("dividend");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for dividend failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarStockDividend: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_STOCK_DIVIDEND, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("stock_dividend");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for stock dividend failed");
                case 6:
                    data = responds.data;
                    ;
                    ;
                    return _ctx.abrupt("return", data);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    getCalendarStocksplit: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_STOCKSPLIT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("stocksplit");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for stocksplit failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarReversesplit: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_REVERSESPLIT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("reversesplit");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for reverse split failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarRightIssue: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_RIGHTISSUE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("rightissue");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for right issue failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarWarrant: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_WARRANT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("warrant");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for warrant failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarBonus: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_BONUS, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("bonus");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for bonus failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarTender: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_TENDER, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("tenderoffer");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for tender offer failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarRups: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_RUPS, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("rups");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for RUPS failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarPubex: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_PUBEX, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("pubex");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for PUBEX failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarIpo: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_IPO, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("ipo");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for IPO failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    })))
};
var extraReducer = function(builder) {
    builder.addCase(effects.getCalendarToday.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarToday.isLoading = false;
        state.calendarToday.data = data;
        state.calendarToday.message = message;
    }).addCase(effects.getCalendarToday.pending, function(state, action) {
        state.calendarToday.isLoading = true;
    }).addCase(effects.getCalendarToday.rejected, function(state, action) {
        state.calendarToday.isLoading = false;
        state.calendarToday.error = action.payload.error;
    }).addCase(effects.getCalendarEconomic.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarEconomic.data = data;
        state.calendarEconomic.message = message;
        state.calendarEconomic.isLoading = false;
    }).addCase(effects.getCalendarEconomic.pending, function(state, action) {
        state.calendarEconomic.isLoading = true;
    }).addCase(effects.getCalendarEconomic.rejected, function(state, action) {
        state.calendarEconomic.error = action.payload.error;
        state.calendarEconomic.isLoading = false;
    }).addCase(effects.getCalendarCashDividend.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarCashDividend.data = data;
        state.calendarCashDividend.message = message;
        state.calendarCashDividend.isLoading = false;
    }).addCase(effects.getCalendarCashDividend.pending, function(state, action) {
        state.calendarCashDividend.isLoading = true;
    }).addCase(effects.getCalendarCashDividend.rejected, function(state, action) {
        state.calendarCashDividend.error = action.payload.error;
        state.calendarCashDividend.isLoading = false;
    }).addCase(effects.getCalendarStockDividend.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarStockDividend.data = data;
        state.calendarStockDividend.message = message;
        state.calendarStockDividend.isLoading = false;
    }).addCase(effects.getCalendarStockDividend.pending, function(state, action) {
        state.calendarStockDividend.isLoading = true;
    }).addCase(effects.getCalendarStockDividend.rejected, function(state, action) {
        state.calendarStockDividend.error = action.payload.error;
        state.calendarStockDividend.isLoading = false;
    }).addCase(effects.getCalendarStocksplit.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarStocksplit.data = data;
        state.calendarStocksplit.message = message;
        state.calendarStocksplit.isLoading = false;
    }).addCase(effects.getCalendarStocksplit.pending, function(state, action) {
        state.calendarStocksplit.isLoading = true;
    }).addCase(effects.getCalendarStocksplit.rejected, function(state, action) {
        state.calendarStocksplit.error = action.payload.error;
        state.calendarStocksplit.isLoading = false;
    }).addCase(effects.getCalendarReversesplit.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarReversesplit.data = data;
        state.calendarReversesplit.message = message;
        state.calendarReversesplit.isLoading = false;
    }).addCase(effects.getCalendarReversesplit.pending, function(state, action) {
        state.calendarReversesplit.isLoading = true;
    }).addCase(effects.getCalendarReversesplit.rejected, function(state, action) {
        state.calendarReversesplit.error = action.payload.error;
        state.calendarReversesplit.isLoading = false;
    }).addCase(effects.getCalendarRightIssue.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarRightIssue.data = data;
        state.calendarRightIssue.message = message;
        state.calendarRightIssue.isLoading = false;
    }).addCase(effects.getCalendarRightIssue.pending, function(state, action) {
        state.calendarRightIssue.isLoading = true;
    }).addCase(effects.getCalendarRightIssue.rejected, function(state, action) {
        state.calendarRightIssue.error = action.payload.error;
        state.calendarRightIssue.isLoading = false;
    }).addCase(effects.getCalendarWarrant.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarWarrant.data = data;
        state.calendarWarrant.message = message;
        state.calendarWarrant.isLoading = false;
    }).addCase(effects.getCalendarWarrant.pending, function(state, action) {
        state.calendarWarrant.isLoading = true;
    }).addCase(effects.getCalendarWarrant.rejected, function(state, action) {
        state.calendarWarrant.error = action.payload.error;
        state.calendarWarrant.isLoading = false;
    }).addCase(effects.getCalendarBonus.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarBonus.data = data;
        state.calendarBonus.message = message;
        state.calendarBonus.isLoading = false;
    }).addCase(effects.getCalendarBonus.pending, function(state, action) {
        state.calendarBonus.isLoading = true;
    }).addCase(effects.getCalendarBonus.rejected, function(state, action) {
        state.calendarBonus.error = action.payload.error;
        state.calendarBonus.isLoading = false;
    }).addCase(effects.getCalendarTender.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarTender.data = data;
        state.calendarTender.message = message;
        state.calendarTender.isLoading = false;
    }).addCase(effects.getCalendarTender.pending, function(state, action) {
        state.calendarTender.isLoading = true;
    }).addCase(effects.getCalendarTender.rejected, function(state, action) {
        state.calendarTender.error = action.payload.error;
        state.calendarTender.isLoading = false;
    }).addCase(effects.getCalendarRups.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarRups.data = data;
        state.calendarRups.message = message;
        state.calendarRups.isLoading = false;
    }).addCase(effects.getCalendarRups.pending, function(state, action) {
        state.calendarRups.isLoading = true;
    }).addCase(effects.getCalendarRups.rejected, function(state, action) {
        state.calendarRups.error = action.payload.error;
        state.calendarRups.isLoading = false;
    }).addCase(effects.getCalendarPubex.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarPubex.data = data;
        state.calendarPubex.message = message;
        state.calendarPubex.isLoading = false;
    }).addCase(effects.getCalendarPubex.pending, function(state, action) {
        state.calendarPubex.isLoading = true;
    }).addCase(effects.getCalendarPubex.rejected, function(state, action) {
        state.calendarPubex.error = action.payload.error;
        state.calendarPubex.isLoading = false;
    }).addCase(effects.getCalendarIpo.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarIpo.data = data;
        state.calendarIpo.message = message;
        state.calendarIpo.isLoading = false;
    }).addCase(effects.getCalendarIpo.pending, function(state, action) {
        state.calendarIpo.isLoading = true;
    }).addCase(effects.getCalendarIpo.rejected, function(state, action) {
        state.calendarIpo.error = action.payload.error;
        state.calendarIpo.isLoading = false;
    });
};
var calendarSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "calendar",
    initialState: initialState,
    // for non-async reducer logic
    reducers: {},
    // for async reducer logic
    extraReducers: extraReducer
});
/* harmony default export */ var slice = (calendarSlice);


/***/ }),

/***/ 66620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useLivePriceStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var livePriceState = {
    symbols: {}
};
var livePriceActions = function(set) {
    return {
        setLivePriceSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useLivePriceStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, livePriceState, livePriceActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 25288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useMarketMoverStore; }
/* harmony export */ });
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);


var useMarketMoverStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        request: {},
        setMoverRequest: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(state, function(draft) {
                    if (!value) delete draft.request[key];
                    else draft.request[key] = value;
                });
            });
        }
    };
});


/***/ }),

/***/ 23782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useOrderbookStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var orderbookState = {
    symbols: {}
};
var orderbookActions = function(set) {
    return {
        setOrderbookSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useOrderbookStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, orderbookState, orderbookActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 87637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ DatafeedContext; },
  "l": function() { return /* binding */ DatafeedProvider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/lib/api/ws.ts
var ws = __webpack_require__(66679);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/websocket_pb.js + 12 modules
var websocket_pb = __webpack_require__(24513);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/global/Datafeed/store/index.ts



var datafeedState = {
    channel: {},
    error: undefined
};
var datafeedActions = function(set) {
    return {
        setChannel: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.channel = (0,_object_spread/* default */.Z)({}, draft.channel, value);
                });
            });
        },
        setError: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.error = value;
                });
            });
        }
    };
};
var useDatafeedStore = (0,esm/* default */.ZP)(function(set, get, store, storeMutation) {
    return (0,_object_spread/* default */.Z)({}, datafeedState, datafeedActions(set, get, store, storeMutation));
});

// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.ts
var liveprice_store = __webpack_require__(66620);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.ts
var orderbook_store = __webpack_require__(23782);
// EXTERNAL MODULE: ./src/global/Datafeed/UseMarketMover/marketmover.store.ts
var marketmover_store = __webpack_require__(25288);
;// CONCATENATED MODULE: ./src/global/Datafeed/index.tsx


















var DatafeedContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var MAX_RECONNECT_COUNTER = 5;
var routesBlacklist = [
    "/logout"
];
var DatafeedProvider = function(param) {
    var _heartbeatDuration = param.heartbeatDuration, heartbeatDuration = _heartbeatDuration === void 0 ? 10000 : _heartbeatDuration, isLoggedIn = param.isLoggedIn, children = param.children;
    var router = (0,next_router.useRouter)();
    var socket = (0,react.useRef)();
    var actionsRef = (0,react.useRef)({});
    var reconnectCounter = (0,react.useRef)(1);
    var isLoggedInRef = (0,react.useRef)(false);
    var authRetries = (0,react.useRef)(0);
    var ref = (0,react.useState)(), authToken = ref[0], setAuthToken = ref[1];
    var ref1 = (0,react.useState)(false), isSocketConnected = ref1[0], setConnectionStatus = ref1[1];
    var isBlacklisted = (0,react.useMemo)(function() {
        return routesBlacklist.includes(router.pathname);
    }, [
        router.pathname
    ]);
    var ref2 = useDatafeedStore(function(state) {
        return {
            setChannel: state.setChannel,
            setError: state.setError,
            error: state.error,
            channel: state.channel
        };
    }), setChannel = ref2.setChannel, setError = ref2.setError, error = ref2.error, channel = ref2.channel;
    var livePriceStoreSymbols = (0,liveprice_store/* useLivePriceStore */.H)(function(s) {
        return s.symbols;
    });
    var orderbookStoreSymbols = (0,orderbook_store/* useOrderbookStore */.a)(function(s) {
        return s.symbols;
    });
    var marketMoverList = (0,marketmover_store/* useMarketMoverStore */.x)(function(s) {
        return s.request;
    });
    var initSocket = function() {
        setAuthToken(undefined);
        socket.current = new WebSocket("wss://wss-trading.stockbit.com/ws");
        socket.current.binaryType = "arraybuffer";
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("open", handleAuth, {
            once: true
        });
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("close", handleReconnection, {
            once: true
        });
        window.datafeedSocket = socket.current;
    };
    var resetSocket = function() {
        socket.current.close();
        socket.current = undefined;
        window.datafeedSocket = undefined;
        setAuthToken(undefined);
    };
    var sendMessageChannel = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(authToken, messageChannel) {
            var ref, ref1, ref2, userId, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            channel: messageChannel,
                            key: authToken,
                            userId: userId
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(authToken, messageChannel) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendPingHeartbeat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current || ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return");
                    case 4:
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            ping: {
                                message: "ping"
                            }
                        }).toBinary();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.send(buffer);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendPingHeartbeat() {
            return _ref.apply(this, arguments);
        };
    }();
    var combinedChannel = (0,react.useMemo)(function() {
        var flattenedLivePriceStoreSymbols = Object.values(livePriceStoreSymbols).flat();
        var flattenedOrderbookStoreSymbols = Object.values(orderbookStoreSymbols).flat();
        var _liveprice, _orderBook;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, channel), {
            liveprice: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_liveprice = channel.liveprice) !== null && _liveprice !== void 0 ? _liveprice : []).concat((0,_to_consumable_array/* default */.Z)(flattenedLivePriceStoreSymbols)))),
            orderBook: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_orderBook = channel.orderBook) !== null && _orderBook !== void 0 ? _orderBook : []).concat((0,_to_consumable_array/* default */.Z)(flattenedOrderbookStoreSymbols)))),
            marketMover: Object.values(marketMoverList)
        });
    }, [
        channel,
        livePriceStoreSymbols,
        orderbookStoreSymbols,
        marketMoverList
    ]);
    var handleSendChannel = (0,react.useCallback)(lodash_debounce_default()(sendMessageChannel, 100), []);
    var setAction = function(channelKey, actionKey, callbackFn) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            if (!draft[channelKey]) draft[channelKey] = {};
            draft[channelKey][actionKey] = callbackFn;
        });
    };
    var removeAction = function(channelKey, actionKey) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            var ref;
            if (draft === null || draft === void 0 ? void 0 : (ref = draft[channelKey]) === null || ref === void 0 ? void 0 : ref[actionKey]) delete draft[channelKey][actionKey];
        });
    };
    var handleUnauthorized = function(message) {
        if (authRetries.current > 3) {
            setError(message.error);
            return;
        }
        authRetries.current += 1;
        setAuthToken(undefined);
        // eslint-disable-next-line no-use-before-define
        handleAuth();
    };
    var handleErrorMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        // Consider moving the error handling code to a separate 'utils' module
                        // if the amount of error handling logic is increasing
                        if ((message === null || message === void 0 ? void 0 : (ref = message.error) === null || ref === void 0 ? void 0 : ref.code) === 401) handleUnauthorized(message);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleErrorMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var dataRaw, messageChannel, messageCase, value, decodedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataRaw = websocket_pb/* WebsocketWrapMessageChannel.fromBinary */.iU.fromBinary(new Uint8Array(message.data));
                        messageChannel = dataRaw.messageChannel;
                        messageCase = messageChannel.case, value = messageChannel.value;
                        decodedMessage = (0,_define_property/* default */.Z)({}, messageCase, value);
                        if (decodedMessage === null || decodedMessage === void 0 ? void 0 : decodedMessage.error) handleErrorMessage(decodedMessage);
                        Object.keys(decodedMessage).forEach(function(messageChannelKey) {
                            Object.values(actionsRef.current[messageChannelKey] || {}).forEach(function(callbackFn) {
                                callbackFn(decodedMessage);
                            });
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    // handleHeartbeatMessage will only called when ping message available
    // filtered on handleMessage
    var handleHeartbeatMessage = function() {
        setTimeout(function() {
            return sendPingHeartbeat();
        }, heartbeatDuration);
    };
    var handleAuth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, userId, data, bodyData, key, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ref2 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref2.id;
                        _ctx.next = 4;
                        return ws/* default.getWSTradingKey */.Z.getWSTradingKey();
                    case 4:
                        data = _ctx.sent.data;
                        bodyData = data.data;
                        key = bodyData.key;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            key: key,
                            userId: userId
                        }).toBinary();
                        (ref = socket.current) === null || ref === void 0 ? void 0 : ref.send(buffer);
                        setAuthToken(key);
                        setAction("ping", "pingResponse", handleHeartbeatMessage);
                        sendPingHeartbeat();
                        (ref1 = socket.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("message", handleMessage);
                        setConnectionStatus(true);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAuth() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReconnection = function() {
        if (!isLoggedInRef.current) return;
        if (reconnectCounter.current > MAX_RECONNECT_COUNTER) {
            setError({
                code: 503,
                message: "Maximum reconnection"
            });
            return;
        }
        reconnectCounter.current += 1;
        setConnectionStatus(false);
        initSocket();
    };
    (0,react.useEffect)(function() {
        if (isBlacklisted) return;
        isLoggedInRef.current = isLoggedIn;
        if (!socket.current && isLoggedIn) initSocket();
        else if (socket.current && !isLoggedIn) resetSocket();
    }, [
        isLoggedIn,
        isBlacklisted
    ]);
    (0,react.useEffect)(function() {
        if (authToken) handleSendChannel(authToken, combinedChannel);
    }, [
        authToken,
        handleSendChannel,
        combinedChannel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedContext.Provider, {
        value: {
            socket: socket.current,
            isSocketConnected: isSocketConnected,
            error: error,
            setChannel: setChannel,
            setAction: setAction,
            removeAction: removeAction,
            isAuthorized: !!authToken
        },
        children: children
    });
};


/***/ }),

/***/ 63600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qd": function() { return /* binding */ INDEX_DATA_FILTER; },
/* harmony export */   "ce": function() { return /* binding */ QUERY_KEY_DATA; },
/* harmony export */   "e_": function() { return /* binding */ FETCH_STATUS; },
/* harmony export */   "n0": function() { return /* binding */ FILTER_CHOICE; },
/* harmony export */   "t6": function() { return /* binding */ LIST_CHOICE; }
/* harmony export */ });
/* unused harmony exports SUGGESTIONS_PERPAGE, LIMIT_SEARCH_USER, USER_TYPES */
/* harmony import */ var features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28635);

var USER_TYPES = {
    OFFICIAL_USER: "OFFICIAL",
    TOP: "TOP"
};
var SUGGESTIONS_PERPAGE = 30;
var LIMIT_SEARCH_USER = 20;
var QUERY_KEY_DATA = {
    suggested: "getDataFriendSuggestionsListTrendingWidget",
    trending: "getDataTrendingList"
};
// fetch statuses
var FETCH_STATUS = {
    IDLE: "idle",
    PENDING: "pending",
    RESOLVED: "resolved",
    REJECTED: "rejected"
};
var FILTER_CHOICE = [
    {
        label: "Weekly",
        value: features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__/* .TrendingTimeFrame.ONE_WEEK */ .b.ONE_WEEK
    },
    {
        label: "Monthly",
        value: features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__/* .TrendingTimeFrame.ONE_MONTH */ .b.ONE_MONTH
    },
    {
        label: "All-time",
        value: features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__/* .TrendingTimeFrame.ALL */ .b.ALL
    }, 
];
var LIST_CHOICE = {
    SUGGESTED: "suggested",
    TRENDING: "trending"
};
var INDEX_DATA_FILTER = {
    SUGGESTED: "useSuggestionList",
    TRENDING: "useTrendingList"
};



/***/ }),

/***/ 64999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);


var useTradingAccount = function() {
    var tradingType = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountType;
    });
    var isRealTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL;
    var isVirtualTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL;
    return {
        tradingType: tradingType,
        isRealTrading: isRealTrading,
        isVirtualTrading: isVirtualTrading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingAccount);


/***/ }),

/***/ 61942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ entities_livestream; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/livestream.ts
/* eslint-disable import/named */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 

var request = (0,requestExodus/* default */.Z)();
var LIVE_STREAM_URL = "".concat(api/* API_EXODUS_URL */.q7, "/live-stream");
/**
 * Get Livestreams Event List
 * @param { Object } params
 * @param {number=} params.page
 * @param {string=} params.limit
 * @param {string=} params.status
 * @returns {APIResponse}
 */ var getEventList = function(params) {
    return request.get("".concat(LIVE_STREAM_URL, "/event"), {
        params: params
    });
};
/**
 * Get Livestream Event
 * @param {string|number=} id
 * @returns {APIResponse}
 */ var getEvent = function(id) {
    return request.get("".concat(LIVE_STREAM_URL, "/event/").concat(id));
};
/**
 * Write Question
 * @param { Object } params
 * @param {number=} params.id
 * @param {string=} params.question
 * @returns {APIResponse}
 */ var writeQuestion = function(params) {
    return request.post("".concat(LIVE_STREAM_URL, "/event/").concat(params.id, "/question"), {
        question: params.question
    });
};
/**
 * Get Nont Login Livestream Event
 * @param {string|number=} id
 * @returns {APIResponse}
 */ var getEventNonLogin = function(id) {
    return request.get("".concat(LIVE_STREAM_URL, "/non-login/event/").concat(id));
};
/* harmony default export */ var livestream = ({
    getEventList: getEventList,
    getEvent: getEvent,
    writeQuestion: writeQuestion,
    getEventNonLogin: getEventNonLogin
});

;// CONCATENATED MODULE: ./src/lib/entities/livestream.ts








/**
 * Note for event filtered data Schema
 * because we pass status as argument, we will use that as key to save the response
 * the schema will look like this
 *
 * data[eventStatus]: [
 *   { ... }
 * ]
 */ var initialState = {
    eventList: {
        data: [],
        isLoading: false,
        message: "",
        error: ""
    },
    eventFiltered: {
        data: {},
        isLoading: false,
        isLoadingMore: false,
        hasMore: false,
        message: "",
        error: ""
    },
    event: {
        data: null,
        isLoading: false,
        message: "",
        error: ""
    },
    writeQuestion: {
        data: null,
        isLoading: false,
        message: "",
        error: ""
    }
};
var liveStream = function(state) {
    return state.liveStream;
};
var selectors = (0,es/* createSelector */.P1)(liveStream, function(liveStreamState) {
    return {
        events: liveStreamState.eventList,
        event: liveStreamState.event,
        eventFiltered: liveStreamState.eventFiltered,
        writeQuestions: liveStreamState.writeQuestion
    };
});
var CONTEXT = "@feature/livestream";
var actionType = {
    GET_EVENTS: "".concat(CONTEXT, "/GET_EVENTS"),
    GET_EVENTS_FILTERED: "".concat(CONTEXT, "/GET_EVENTS_FILTERED"),
    GET_EVENT: "".concat(CONTEXT, "/GET_EVENT"),
    WRITE_QUESTION: "".concat(CONTEXT, "/WRITE_QUESTION")
};
var effects = {
    getEventList: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENTS, // @ts-ignore
    (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getEventList({
                        page: 1,
                        limit: 20
                    });
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed to get event list");
                case 6:
                    _data = response.data, data = _data.data, message = _data.message;
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getEvent: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return getEvent(props);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 6:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }()),
    getEventListFiltered: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENTS_FILTERED, function() {
        var _ref = // @ts-ignore
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var _page, page, _limit, limit, status, response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _page = props.page, page = _page === void 0 ? 1 : _page, _limit = props.limit, limit = _limit === void 0 ? 16 : _limit, status = props.status;
                        _ctx.next = 4;
                        return getEventList({
                            page: page,
                            limit: limit,
                            status: status
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 7:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }()),
    writeQuestion: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.WRITE_QUESTION, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return writeQuestion(props);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 6:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }())
};
var extraReducers = function(builder) {
    builder.addCase(effects.getEventList.pending, function(state) {
        state.eventList.isLoading = true;
        state.eventList.error = null;
    }).addCase(effects.getEventList.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.eventList.error = error;
        } else {
            state.eventList.data = data;
        }
        state.eventList.message = message;
        state.eventList.isLoading = false;
    }).addCase(effects.getEventList.rejected, function(state, action) {
        state.eventList.isLoading = false;
        state.eventList.error = action.payload.error;
    }).addCase(effects.getEvent.pending, function(state) {
        state.event.isLoading = true;
        state.event.error = null;
    }).addCase(effects.getEvent.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.event.error = error;
        } else {
            state.event.data = data;
        }
        state.event.message = message;
        state.event.isLoading = false;
    }).addCase(effects.getEvent.rejected, function(state, action) {
        state.event.isLoading = false;
        state.event.error = action.payload.error;
    }).addCase(effects.writeQuestion.pending, function(state) {
        state.writeQuestion.isLoading = true;
        state.writeQuestion.error = null;
    }).addCase(effects.writeQuestion.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.writeQuestion.error = error;
        } else {
            state.writeQuestion.data = data;
        }
        state.writeQuestion.message = message;
        state.writeQuestion.isLoading = false;
    }).addCase(effects.writeQuestion.rejected, function(state, action) {
        state.writeQuestion.isLoading = false;
        state.writeQuestion.error = action.payload.error;
    }).addCase(effects.getEventListFiltered.pending, function(state, action) {
        var page = action.meta.arg.page;
        state.eventFiltered.error = null;
        if (page > 1) {
            state.eventFiltered.isLoadingMore = true;
        } else {
            state.eventFiltered.isLoading = true;
        }
    }).addCase(effects.getEventListFiltered.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        var _arg = action.meta.arg, page = _arg.page, status = _arg.status;
        if (error) {
            state.eventFiltered.error = error;
        } else {
            if (page > 1) {
                state.eventFiltered.data = (0,_define_property/* default */.Z)({}, status, (0,_to_consumable_array/* default */.Z)(state.eventFiltered.data[status]).concat((0,_to_consumable_array/* default */.Z)(data)));
                state.eventFiltered.isLoadingMore = false;
            } else {
                state.eventFiltered.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.eventFiltered.data), (0,_define_property/* default */.Z)({}, status, data));
                state.eventFiltered.isLoading = false;
            }
            if (data.length === 16) {
                state.eventFiltered.hasMore = true;
            } else {
                state.eventFiltered.hasMore = false;
            }
        }
        state.eventFiltered.message = message;
    }).addCase(effects.getEventListFiltered.rejected, function(state, action) {
        state.eventFiltered.isLoading = false;
        state.eventFiltered.error = action.payload.error;
    });
};
var liveStreamSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "livestream",
    initialState: initialState,
    reducers: {},
    extraReducers: extraReducers
});
/* harmony default export */ var entities_livestream = (liveStreamSlice);


/***/ }),

/***/ 42826:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Upload image handler
 * @param file - File to be uploaded
 * @param url - AWS Bucket URL
 * @param awsFields - Additional aws fields from `getPolicy` API
 * @param - type upload chat|stream
 * @returns {Promise<*>} fetch function
 */ var uploadHandler = function(file, url, awsFields, type) {
    return new Promise(function(resolve, reject) {
        var fd = new FormData();
        var formerFile = null;
        // eslint-disable-next-line no-underscore-dangle
        if (file._file) formerFile = file._file;
        // eslint-disable-next-line array-callback-return
        if (type === "chat") {
            awsFields.map(function(field) {
                return fd.append(field.name, field.value);
            });
        } else if (type === "stream") {
            awsFields.map(function(field) {
                return fd.append(field.key, field.value);
            });
        }
        if (!formerFile) {
            fd.append("file", file);
        } else {
            fd.append("file", formerFile);
        }
        return fetch(url, {
            method: "POST",
            cache: "default",
            body: fd,
            mode: "no-cors"
        }).then(function(response) {
            resolve(response.ok);
        }).catch(function(error) {
            reject(new Error(error));
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (uploadHandler);


/***/ })

}]);